export var COLOR;
(function (COLOR) {
    COLOR["TEXT"] = "text";
    COLOR["LIGHT_TEXT"] = "lightText";
    COLOR["BACKGROUND"] = "background";
    COLOR["TRANSPARENT"] = "transparent";
    COLOR["PRIMARY"] = "primary";
    COLOR["TEXT_ON_PRIMARY"] = "textOnPrimary";
    COLOR["PRIMARY_HIGHLIGHT"] = "primaryHighlight";
    COLOR["SECONDARY"] = "secondary";
    COLOR["TEXT_ON_SECONDARY"] = "textOnSecondary";
    COLOR["SECONDARY_HIGHLIGHT"] = "secondaryHighlight";
    COLOR["WHITE"] = "white";
    COLOR["WARM_WHITE"] = "warmWhite";
    COLOR["WARM_WHITE_DARK"] = "warmWhiteDark";
    COLOR["BLACK"] = "black";
    COLOR["DARK_GRAY"] = "darkGray";
    COLOR["GRAY"] = "gray";
    COLOR["LIGHT_GRAY"] = "lightGray";
    COLOR["EXTRA_LIGHT_GRAY"] = "extraLightGray";
    COLOR["EXTRA_EXTRA_LIGHT_GRAY"] = "extraExtraLightGray";
    COLOR["SUCCESS"] = "ndTertiary1";
    COLOR["ND_BLUE"] = "ndBlue";
    COLOR["ND_BLUE_DARK"] = "ndBlueDark";
    COLOR["ND_BLUE_LIGHT"] = "ndBlueLight";
    COLOR["ND_BLUE_BRIGHT"] = "ndBlueBright";
    COLOR["ND_GOLD"] = "ndGold";
    COLOR["ND_GOLD_LIGHT"] = "ndGoldLight";
    COLOR["ND_GOLD_DARK"] = "ndGoldDark";
    COLOR["ND_GREEN"] = "ndGreem";
    COLOR["ND_GREEN_LIGHT"] = "ndGreenLight";
    COLOR["ND_SKY_BLUE"] = "ndSkyBlue";
    COLOR["ND_SKY_BLUE_DARK"] = "ndSkyBlueDark";
    COLOR["ND_SKY_BLUE_LIGHT"] = "ndSkyBlueLight";
    COLOR["ND_METALLIC_GOLD"] = "ndMetallicGold";
    COLOR["ND_METALLIC_GOLD_LIGHT"] = "ndMetallicGoldLight";
    COLOR["ND_PROVOST_BLUE"] = "ndProvostBlue";
    COLOR["ND_SECONDARY_1"] = "ndSecondary1";
    COLOR["ND_SECONDARY_2"] = "ndSecondary2";
    COLOR["ND_SECONDARY_3"] = "ndSecondary3";
    COLOR["ND_SECONDARY_4"] = "ndSecondary4";
    COLOR["ND_SECONDARY_5"] = "ndSecondary5";
    COLOR["ND_SECONDARY_6"] = "ndSecondary6";
    COLOR["ND_TERTIARY_1"] = "ndTertiary1";
    COLOR["ND_TERTIARY_2"] = "ndTertiary2";
    COLOR["ND_TERTIARY_3"] = "ndTertiary3";
    COLOR["ND_TERTIARY_4"] = "ndTertiary4";
    COLOR["ND_TERTIARY_5"] = "ndTertiary5";
    COLOR["ND_TERTIARY_6"] = "ndTertiary6";
    COLOR["ALERT_INFORMATIONAL_BG"] = "alertInformationalBg";
    COLOR["ALERT_INFORMATIONAL_BORDER"] = "alertInformationalBorder";
    COLOR["ALERT_INFORMATIONAL_YELLOW_BG"] = "alertInformationalYellowBg";
    COLOR["ALERT_INFORMATIONAL_YELLOW_BORDER"] = "alertInformationalYellowBorder";
    COLOR["ALERT_WARNING_BG"] = "alertWarningBg";
    COLOR["ALERT_WARNING_BORDER"] = "alertWarningBorder";
    COLOR["ALERT_SUCCESS_BG"] = "alertSuccessBg";
    COLOR["ALERT_SUCCESS_BORDER"] = "ndTertiary1";
})(COLOR || (COLOR = {}));
export const colors = {
    [COLOR.TEXT]: '#333333',
    [COLOR.LIGHT_TEXT]: '#767676',
    [COLOR.BACKGROUND]: '#ffffff',
    [COLOR.TRANSPARENT]: 'rgba(0,0,0,0)',
    [COLOR.PRIMARY]: '#0c2340',
    [COLOR.TEXT_ON_PRIMARY]: '#ffffff',
    [COLOR.PRIMARY_HIGHLIGHT]: '#000d1d',
    [COLOR.SECONDARY]: '#d39f10',
    [COLOR.SECONDARY_HIGHLIGHT]: '#ddcc70',
    [COLOR.TEXT_ON_SECONDARY]: '#040401',
    [COLOR.WHITE]: '#ffffff',
    [COLOR.WARM_WHITE]: '#f8f4ec',
    [COLOR.WARM_WHITE_DARK]: '#efe9d9',
    [COLOR.BLACK]: '#000000',
    [COLOR.DARK_GRAY]: '#333333',
    [COLOR.GRAY]: '#767676',
    [COLOR.LIGHT_GRAY]: '#d2d2d2',
    [COLOR.EXTRA_LIGHT_GRAY]: '#e2e2e2',
    [COLOR.EXTRA_EXTRA_LIGHT_GRAY]: '#f2f2f2',
    [COLOR.ND_GOLD]: '#ae9142',
    [COLOR.ND_GOLD_LIGHT]: '#d39f10',
    [COLOR.ND_GOLD_DARK]: '#8c7535',
    [COLOR.ND_GREEN]: '#0a843d',
    [COLOR.ND_GREEN_LIGHT]: '#b3dac5',
    [COLOR.ND_BLUE]: '#0c2340',
    [COLOR.ND_BLUE_DARK]: '#081629',
    [COLOR.ND_BLUE_LIGHT]: '#143865',
    [COLOR.ND_BLUE_BRIGHT]: '#1c4f8f',
    [COLOR.ND_SKY_BLUE]: '#e1e8f2',
    [COLOR.ND_SKY_BLUE_DARK]: '#c1cddd',
    [COLOR.ND_SKY_BLUE_LIGHT]: '#edf2f9',
    [COLOR.ND_METALLIC_GOLD]: '#ae9142',
    [COLOR.ND_METALLIC_GOLD_LIGHT]: '#CEBE8E',
    [COLOR.ND_PROVOST_BLUE]: '#002a5d',
    [COLOR.ND_SECONDARY_1]: '#5aabbc',
    [COLOR.ND_SECONDARY_2]: '#999623',
    [COLOR.ND_SECONDARY_3]: '#5f1709',
    [COLOR.ND_SECONDARY_4]: '#465510',
    [COLOR.ND_SECONDARY_5]: '#f6e7a1',
    [COLOR.ND_SECONDARY_6]: '#302205',
    [COLOR.ND_TERTIARY_1]: '#00823E',
    [COLOR.ND_TERTIARY_2]: '#4a3651',
    [COLOR.ND_TERTIARY_3]: '#ffcf01',
    [COLOR.ND_TERTIARY_4]: '#aa272f',
    [COLOR.ND_TERTIARY_5]: '#5a412f',
    [COLOR.ND_TERTIARY_6]: '#ba6f2e',
    [COLOR.ALERT_INFORMATIONAL_BG]: '#ffb073',
    [COLOR.ALERT_INFORMATIONAL_BORDER]: '#ad7950',
    [COLOR.ALERT_INFORMATIONAL_YELLOW_BG]: '#f8e999',
    [COLOR.ALERT_INFORMATIONAL_YELLOW_BORDER]: '#b3a871',
    [COLOR.ALERT_WARNING_BG]: '#fc7279',
    [COLOR.ALERT_WARNING_BORDER]: '#ad5458',
    [COLOR.ALERT_SUCCESS_BG]: '#edffea',
};
